/** A Stripe return URL is not proof that the subscription webhook has arrived. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/api/client";
import { useAuthStore } from "@/stores/auth";
import { billingCopy } from "@/lib/billingCopy";

export default function BillingSuccessPage() {
  const { t, i18n } = useTranslation();
  const token = useAuthStore(state => state.token);
  const [confirmed, setConfirmed] = useState(false);
  const [checking, setChecking] = useState(true);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    let live = true;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let polls = 0;
    setConfirmed(false);
    setChecking(true);
    async function check() {
      if (!token) { setChecking(false); return; }
      try {
        const { data } = await api.get<{ access_available: boolean }>("/billing/my-subscription", { signal: controller.signal });
        if (!live || useAuthStore.getState().token !== token) return;
        if (data.access_available === true) { setConfirmed(true); setChecking(false); return; }
        polls += 1;
        if (polls < 10) { timer = setTimeout(() => void check(), 3000); return; }
      } catch { if (!live || useAuthStore.getState().token !== token) return; }
      setChecking(false);
    }
    void check();
    return () => { live = false; controller.abort(); if (timer) clearTimeout(timer); };
  }, [token, attempt]);

  return <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-5 py-10 text-center">
    <h1 className="font-serif text-2xl font-medium text-navy">{billingCopy(i18n.language, 6)}</h1>
    <p role="status" className="mt-3 text-taupe">{billingCopy(i18n.language, confirmed ? 7 : 1)}</p>
    {confirmed
      ? <Link to="/" className="mt-6 rounded-md bg-amber px-6 py-3 font-bold text-navy-deep">{t("nav.home")}</Link>
      : <button type="button" disabled={checking} onClick={() => setAttempt(value => value + 1)} className="mt-6 rounded-md bg-amber px-6 py-3 font-bold text-navy-deep disabled:opacity-50">{checking ? t("billing.loading") : t("common.retry")}</button>}
  </div>;
}
